export const es = {
  $vuetify: {
    // C
    close: 'Cerrar',
    chooseOption: 'Elegir una opción',

    // Q
    qrcodeSummary: 'Escanee el código QR con su smartphone para ver el producto en realidad aumentada',

    // S
    seeInAR: 'Ver en casa',

  },
}
